import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { ToastContainer, notify } from '../../libraries/notifications';
import { Form, Field } from 'react-final-form';
import config from '../../config';
import { history } from '../../routes';
import { getObjectWithJsonDataToFormValues, getOwner } from '../../libraries/utils';
import SearchInput from '../../components/forms/SearchInput';
import LayoutWithSidebar from '../../components/layout/LayoutWithSidebar';
import PatientHistoryElement from '../../components/customs/PatientHistoryElement';
import appointmentsActions from '../../context/appointments/actions';
import userActions from '../../context/users/actions';

class History extends React.Component {

  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
      appointments: [],
      professional: null,
      search: "",
      renderHistory: true,
    }
  }

  componentDidMount() {
      this.getPatientappointments();
    }


  getPatientappointments = async () => {
    const params = { target: getOwner(this.props.auth.user), type: config.TRANSACTIONS.BOOK.TYPE, status: config.TRANSACTIONS.BOOK.STATUS.COMPLETED };
    await this.props.onGetAllAppointments(params);
    const { appointments } = this.props;
    if (appointments.error) {
      notify(this.t(appointments.error.message));
    } else {

      this.setState({ appointments: appointments.items });

      // await this.props.onGetProfessional({ id: appointments.items[0].professional_id });
      // const error = this.props.professional.error;
      // if (error) { 
      //   notify(this.t(error.message));
      // } else {
      //   const professionalData = getObjectWithJsonDataToFormValues(
      //     this.props.professional.item,
      //     ['id', 'first_name', 'last_name', 'cover_image', 'profile_image', 'specialty', 'username', 'description', 'accounts']
      //   );
      //   this.setState({ professional: professionalData });
      // }

    }
  }

  gotoBack = () => {
    history.push(config.ROUTES.HOME)
  }

  searchClear = (form) => {
    form.change('search', undefined);
    this.searchOnClick({search: ''});
  }

  searchOnClick = async (values) => {
    console.log("Search on Click", values.search);
    //if (this.state.search !== values.search || values.search === '') this.setState({ search: values.search || '' }, () => this.getPrescriptions() );
  };


  viewPrescription = (prescription) => {
    const { professional } = this.state;
    history.push(
      config.ROUTES.PRESCRIPTION.replace(':id', prescription.id),
      { from: config.ROUTES.HISTORY }
    )
  }


  render() {
    const { appointments } = this.state;
    return (
      <LayoutWithSidebar
        main={{ className: "bg-base-200"}}
        header={{ 
          title: this.t("Historia clinica"),
        }}
        container={{ className: "px-0"}}
        loading={this.props.appointments.loading || this.props.professional.loading}
      >
        <ToastContainer />
        <section className="h-10 bg-primary"></section>
        {!this.props.appointments.loading && (
          <section className="section-card">
            <Form initialValues={{}} onSubmit={this.searchOnClick}>
              {({ handleSubmit, form, submitting, pristine, values }) => (
                <form onSubmit={handleSubmit} className="w-full max-w-lg mx-auto mb-4">
                  <Field name="search" component={SearchInput} placeholder={this.t("Search")} onClick={this.searchOnClick} onClearClick={() => this.searchClear(form)} />
                </form>
              )}
            </Form>
            <div className="mb-6">
              <ul className="relative wrap overflow-hidden h-full">
                <div className="border-2-2 absolute border-opacity-20 border-gray-700 h-full border"></div>
                {
                  appointments && appointments.map((appointment, index) => {
                    return (
                      <li className="flex justify-between items-center w-full right-timeline ml-5 border-b pb-4">
                        <PatientHistoryElement
                          key={index}
                          appointment={appointment}
                          onClick={this.viewPrescription}
                        />
                      </li>
                    )
                  }
                  )
                }
              </ul>
            </div>
          </section>
        )}
      </LayoutWithSidebar>
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.users.auth,    
    appointments: state.appointments.list,
    professional: state.users.current,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onGetAllAppointments: (params) => dispatch(appointmentsActions.getAll(params)),
    onGetProfessional: (params) => dispatch(userActions.get(params)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(History));
